export const SET_IS_LOADING = '@siteSchedule/SET_IS_LOADING';
export const SET_IS_READY = '@siteSchedule/SET_IS_READY';
export const SET_SINGLE_SITE_SCHEDULE_DATA = '@siteSchedule/SET_SINGLE_SITE_SCHEDULE_DATA';
export const REMOVE_SITE_SCHEDULE_DATA = '@siteSchedule/REMOVE_SITE_SCHEDULE_DATA';
export const CLEAR_SITE_SCHEDULE_DATA = '@siteSchedule/CLEAR_SITE_SCHEDULE_DATA';

export const FETCH_SINGLE_SITE_SCHEDULE_REQUEST = '@siteSchedule/FETCH_SINGLE_SITE_SCHEDULE_REQUEST';

export const CANCEL = '@siteSchedule/CANCEL_HEHE';

export const SET_HAS_ERROR = '@siteSchedule/SET_HAS_ERROR';
